export default __webpack_public_path__ + "static/media/florayfauna3.b6298a5a.jpg";